import { useState, useCallback, useContext } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "../../../shadcn/components/ui/dialog";
import { Button } from "../../../shadcn/components/ui/button";
import { Calendar } from "../../../shadcn/components/ui/calendar";
import ChevronUpSvg from "../../../icons/ChevronUpSvg";
import ChevronDownSvg from "../../../icons/ChevronDownSvg";
interface CalendarDoubleDatePickerProps {
  startDate: Date | null;
  endDate: Date | null;
  setStartDate: React.Dispatch<React.SetStateAction<Date | null>>;
  setEndDate: React.Dispatch<React.SetStateAction<Date | null>>;
}

const CalendarDoubleDatePicker = ({
  startDate,
  endDate,
  setStartDate,
  setEndDate,
}: CalendarDoubleDatePickerProps) => {
  const [open, setOpen] = useState(false);

  const handleDateSelect = (range: { from?: Date; to?: Date }) => {
    if (!range) return;

    const { from: selectedStartDate, to: selectedEndDate } = range;
    setStartDate(selectedStartDate || null);
    setEndDate(selectedEndDate || null);
  };

  const formatDate = (date: Date | null): string => {
    if (!date) return "";
    const day = date.getDate().toString().padStart(2, "0");
    const month = date.toLocaleString("default", { month: "short" });
    const year = date.getFullYear().toString().slice(-2);
    return `${day}/${month}/${year}`;
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button variant="custom" className="min-w-[190px] xl:min-w-[214px]">
          <div className="flex items-center justify-between w-full">
            <p className="text-web-body-lg font-openSans text-brand-bgBlack font-normal flex items-center ">
              {`${formatDate(startDate) || "Start date"} - ${
                formatDate(endDate) || "End date"
              }`}
            </p>
            <div className="ml-2">
              {open ? (
                <ChevronUpSvg width={14} height={14} fill="#7D7D7D" />
              ) : (
                <ChevronDownSvg width={14} height={14} fill="#7D7D7D" />
              )}
            </div>
          </div>
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-[320px] max-h-[700px] sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Select Date Range</DialogTitle>
        </DialogHeader>
        <div className="rounded-md border h-[500px] overflow-y-auto">
          <Calendar
            initialFocus
            mode="range"
            selected={{
              from: startDate || undefined,
              to: endDate || undefined,
            }}
            onSelect={(range: any) => handleDateSelect(range || {})}
            numberOfMonths={2}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CalendarDoubleDatePicker;
